/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, QueryParams, SendRequestPayload } from '../baseClient';
import { 
  CorePayeeCreditNotesSearchParams,
  CreditNoteDtoArrayResponse,
  CreditNoteDtoResponse,
  InvoiceStatusResponse,
  DateTypesResponse
 } from '../types';

  //  CorePayeeCreditNotesClient
class CorePayeeCreditNotesClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly search = (queryParams: CorePayeeCreditNotesSearchParams): AxiosPromise<CreditNoteDtoArrayResponse> => {
        let url_ = "/api/v1/core/payee/credit_notes";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly get = (id: string): AxiosPromise<CreditNoteDtoResponse> => {
        let url_ = "/api/v1/core/payee/credit_notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getStatuses = (): AxiosPromise<InvoiceStatusResponse> => {
        let url_ = "/api/v1/core/payee/credit_notes/statuses";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getDateType = (): AxiosPromise<DateTypesResponse> => {
        let url_ = "/api/v1/core/payee/credit_notes/date_types";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CorePayeeCreditNotesClient
  
export const corePayeeCreditNotesClient = new CorePayeeCreditNotesClient(baseClientConstructorProps);
